import { render, staticRenderFns } from "./AdministrarCuenta.vue?vue&type=template&id=06b372ce&"
import script from "./AdministrarCuenta.vue?vue&type=script&lang=js&"
export * from "./AdministrarCuenta.vue?vue&type=script&lang=js&"
import style0 from "./AdministrarCuenta.vue?vue&type=style&index=0&id=06b372ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports